import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgSidebarWallet = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.642 3a6.004 6.004 0 0 1 5.997 5.998v7.177a6.004 6.004 0 0 1-5.997 5.998H7.998A6.005 6.005 0 0 1 2 16.175V8.998A6.005 6.005 0 0 1 7.998 3zm0 1.5H7.998A4.503 4.503 0 0 0 3.5 8.998v7.177a4.503 4.503 0 0 0 4.498 4.498h8.644a4.503 4.503 0 0 0 4.497-4.498v-.28H17.84a3.446 3.446 0 0 1-3.442-3.438 3.447 3.447 0 0 1 3.442-3.443l3.298-.001v-.015A4.503 4.503 0 0 0 16.642 4.5m4.497 6.013H17.84a1.945 1.945 0 0 0-1.942 1.943c0 1.069.872 1.94 1.942 1.94l3.298-.001zm-2.84 1.13a.75.75 0 0 1 0 1.5h-.313a.75.75 0 0 1 0-1.5zm-5.614-4.105a.75.75 0 0 1 0 1.5h-5.4a.75.75 0 0 1 0-1.5z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSidebarWallet);
export default ForwardRef;
